import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { APPLICATIONS, Apps } from '../_models/mu_data-home-internals';
import { AuthService } from '../_services/auth.service';

@Component({
  selector: 'app-plataformas',
  standalone: true,
  imports: [
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatButtonModule,
    RouterModule,
  ],
  templateUrl: './plataformas.component.html',
  styleUrl: './plataformas.component.scss'
})
export class PlataformasComponent implements OnInit {

  apps: Apps[] = [];

  @ViewChild('appsWrapper', { static: false })
  appsWrapper!: ElementRef;
  scrollInterval: any;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.waitForUserRoles().then(userRoles => {
      this.apps = APPLICATIONS
        .filter(app => this.hasAllowedRole(userRoles, app.allowedRoles))
        .map(app => ({
          ...app,
          route: this.normalizeRoute(app.route)
        }));

      this.startAutoScroll();
    });
  }

  private waitForUserRoles(): Promise<string[]> {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        const data = localStorage.getItem('loggedUser');
        if (data) {
          try {
            const user = JSON.parse(data);
            const roles = Array.isArray(user.rol) ? user.rol : [];
            clearInterval(checkInterval);
            resolve(roles);
          } catch (err) {
            clearInterval(checkInterval);
            resolve([]);
          }
        }
      }, 100); // chequea cada 100ms
    });
  }


  private hasAllowedRole(userRoles: string[], allowedRoles: string[]): boolean {
    return allowedRoles.some(role => userRoles.includes(role));
  }

  isExternalLink(route: string): boolean {
    try {
      const url = new URL(route);
      return url.hostname !== window.location.hostname;
    } catch (_) {
      return false;
    }
  }

  normalizeRoute(route: string): string {
    try {
      const url = new URL(route);
      if (url.hostname === window.location.hostname) {
        return url.pathname + url.search;
      }
      return route;
    } catch {
      return route;
    }
  }

  scrollLeft() {
    this.appsWrapper.nativeElement.scrollBy({ left: -100, behavior: 'smooth' });
  }

  scrollRight() {
    this.appsWrapper.nativeElement.scrollBy({ left: 100, behavior: 'smooth' });
  }

  startAutoScroll() {
    this.scrollInterval = setInterval(() => {
      const wrapper = this.appsWrapper.nativeElement;
      if (wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth) {
        wrapper.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        wrapper.scrollBy({ left: 100, behavior: 'smooth' });
      }
    }, 8200);
  }

  stopAutoScroll() {
    clearInterval(this.scrollInterval);
  }
}
